module.exports = __webpack_public_path__ + "static/media/image_2024-10-13_142806622-removebg-preview.1cef796f.png";